import { fieldFromName } from '@alliance-disposal/wql';
export function findObjectsWithField(obj) {
    const result = [];
    function search(obj) {
        if (typeof obj === 'object' && obj !== null) {
            if (Object.prototype.hasOwnProperty.call(obj, 'field')) {
                result.push(obj);
            }
            for (const key in obj) {
                search(obj[key]);
            }
        }
    }
    search(obj);
    return result;
}
export const filterUnusedBooleanFields = (arr) => {
    return arr.filter((item) => {
        if (item.type === 'BOOLEAN' && item.value === undefined) {
            return false;
        }
        return true;
    });
};
export const countFilterFields = (obj) => {
    const filters = filterUnusedBooleanFields(findObjectsWithField(obj.filters));
    let count = filters.length;
    // IF TYPE IS SELECTED, ADD 1 TO COUNT
    if (obj.type) {
        count++;
    }
    // IF SORT IS SELECTED, ADD 1 TO COUNT
    if (obj?.sort?.field !== undefined && obj?.sort?.direction) {
        count++;
    }
    return { totalCount: count, filterCount: filters.length };
};
export const getHumanReadableGrouping = (index) => {
    if (index.includes('service-grouping')) {
        return 'SERVICE GROUPINGS';
    }
    if (index.includes('order')) {
        return 'ORDERS';
    }
    if (index.includes('receivable')) {
        return 'RECEIVABLES';
    }
    if (index.includes('payable')) {
        return 'PAYABLES';
    }
    if (index.includes('customer')) {
        return 'CUSTOMERS';
    }
    if (index.includes('vendor')) {
        return 'VENDORS';
    }
    if (index.includes('pricing-zone')) {
        return 'PRICING ZONES';
    }
    if (index.includes('hauler-pricing-zone')) {
        return 'HAULER PRICING ZONES';
    }
    if (index.includes('lead')) {
        return 'LEADS';
    }
    if (index.includes('disposal-site')) {
        return 'DISPOSAL SITES';
    }
    if (index.includes('dumpster')) {
        return 'DUMPSTERS';
    }
    return '';
};
export const isNumberStrict = (value) => {
    return (typeof value === 'number' && !isNaN(value)) || value instanceof Number;
};
// RETURNS THE VALUE IN "" OR NULL IF NON EXIST
const findWordInQuotes = (input) => {
    const matches = input.match(/"([^"]*)"/);
    return matches ? matches[1] : null;
};
export const handlePrepareQuery = (query, application) => {
    const search = query?.query || '';
    const searchQuery = {
        query: query?.query || '',
        restrictToFields: query?.restrictToFields || [],
    };
    let multiMatchType = undefined;
    let strippedSearchString = search;
    if (search?.includes(':') && application) {
        const inputArray = [search.slice(0, search.indexOf(':')), search.slice(search.indexOf(':') + 1)];
        const searchableField = inputArray[0];
        const searchValue = inputArray[1];
        const fields = fieldFromName(searchableField, {
            application: application,
        });
        const restrictedFields = new Set();
        fields.map((field) => {
            restrictedFields.add(field.field);
        });
        searchQuery.query = searchValue;
        searchQuery.restrictToFields = Array.from(restrictedFields);
        strippedSearchString = searchValue;
    }
    if (Boolean(findWordInQuotes(strippedSearchString)) && application) {
        multiMatchType = 'phrase_prefix';
        searchQuery.query = strippedSearchString.replace(/"/g, '');
    }
    return { query: searchQuery, multiMatchType: multiMatchType };
};
// CHECKS TO SEE IF QUERY IS SAME AS DEFAULT FILTERS
export const handleCheckIfEqualToDefault = (queryData, defaultFilters) => {
    if (!defaultFilters)
        return false;
    const blankQueryObject = {
        filters: {},
        query: { query: '', restrictToFields: [] },
        sort: { field: undefined, direction: 'DESC' },
        type: '',
    };
    const fullDefaultFilterObject = {
        ...blankQueryObject,
        ...defaultFilters.query,
    };
    if (!fullDefaultFilterObject.query.restrictToFields) {
        fullDefaultFilterObject.query.restrictToFields = [];
    }
    const fullQueryData = {
        ...blankQueryObject,
        ...queryData,
    };
    if (!fullQueryData.query.restrictToFields) {
        fullQueryData.query.restrictToFields = [];
    }
    fullQueryData.filters = filterUnusedBooleanFields(findObjectsWithField(fullQueryData.filters));
    fullDefaultFilterObject.filters = filterUnusedBooleanFields(findObjectsWithField(fullDefaultFilterObject.filters));
    return JSON.stringify(fullQueryData) === JSON.stringify(fullDefaultFilterObject);
};
//# sourceMappingURL=functions.js.map